import { useQuery } from '@tanstack/react-query';
import {
  getCompeticionesByTemporada,
  getCompeticionByIdTemporadaAndId,
} from '../../services/competicionesService';

/**
 * Hook para obtener competiciones por temporada
 * @param {string} idTemporada - ID de la temporada
 * @param {object} options - Opciones de React Query
 */
export const useCompeticiones = (idTemporada, options = {}) => {
  return useQuery({
    queryKey: ['competiciones', idTemporada],
    queryFn: () => getCompeticionesByTemporada(idTemporada, null),
    enabled: !!idTemporada,
    staleTime: 30 * 60 * 1000, // 30 minutos
    ...options,
  });
};

export const competicionByIdTemporadaAndIdQueryOptions = (
  idTemporada,
  idCompeticion,
  options = {}
) => ({
  queryKey: ['competiciones', 'byTemporadaAndId', idTemporada, idCompeticion],
  queryFn: () => getCompeticionByIdTemporadaAndId(idTemporada, idCompeticion, null),
  enabled: !!(idTemporada && idCompeticion),
  staleTime: 30 * 60 * 1000,
  ...options,
});

/**
 * Hook para obtener una competición concreta por temporada e ID
 * @param {string|number} idTemporada - ID de la temporada
 * @param {string|number} idCompeticion - ID de la competición
 * @param {object} options - Opciones de React Query
 */
export const useCompeticionByIdTemporadaAndId = (
  idTemporada,
  idCompeticion,
  options = {}
) => {
  return useQuery(
    competicionByIdTemporadaAndIdQueryOptions(
      idTemporada,
      idCompeticion,
      options
    )
  );
};

export default useCompeticiones;
